import axios from "axios";
// import {Store} from "vuex";
import apiService from "../services/apiService";
import type {IApiResponseTransportation} from "@/interfaces/apiResponseInterfaces/IApiResponseTransportation.interface";
import {axiosHelpers} from "../helpers/axiosHelpers";
import type {Coordinates} from "@/store/states/ICoordinatesState.interface";
import type {ITransportationsRequestQueryParams} from "@/interfaces/IRequestQueryParams.interface";

export default class apiTransportationsService {

    static async getTransportations(
        params: ITransportationsRequestQueryParams
    ): Promise<{data: IApiResponseTransportation[]|null, errors: string[]|null}> {

        let data: IApiResponseTransportation[]|null = [];
        let errors: string[]|null = [];

        // Building url with query parameters
        const requestUrl = new URL(apiService.getTransportationsEndpoint());
        for (const key in params) {
            if (! params.hasOwnProperty(key)) {
                continue;
            }
            requestUrl.searchParams.append(key, params[key]);
        }

        await axios.get(requestUrl.href)
            .then(response => {
                data = response.data;
        })
            .catch(error => {
                errors = axiosHelpers.handleAxiosErrors(error, 'key_unprocessable_content');
        });

        return {data, errors};
    }

    static displayTransportationMarkers(
        map: object,
        payload: Coordinates,
        icons: {origin: string, destination: string, waypoint: string},
        transportation: IApiResponseTransportation
    ): void {

        const markerOrigin = {
            icon: icons.origin,
            coordinates: payload.origin
        };

        const markerDestination = {
            icon: icons.destination,
            coordinates: payload.destination
        };

        const markerWaypoints = payload.waypoints!.map(el => (
            {
                icon: icons.waypoint,
                coordinates: el!.location
            }
        ));

        const allMarkers = [markerOrigin, ...markerWaypoints, markerDestination];
        const cities = [
            {city: transportation.pickup_city.address_to_show, time: transportation.pickup_time},
            ...transportation.transportation_stop.map(city => ({city: city.transportation_address.address_to_show, time: city.time})),
            {city: transportation.dropoff_city.address_to_show, time: transportation.drop_off_time}
        ];

        for (let i = 0; i < allMarkers.length; i++) {
            new (window as any).google.maps.Marker({
                position: allMarkers[i].coordinates,
                map,
                icon: {
                    url: allMarkers[i].icon,
                    labelOrigin: new (window as any).google.maps.Point(11, 50)
                },
                title: cities[i].city,
                label: {
                    text: cities[i].time,
                    className: 'map-marker-label-style',
                    color: 'white',
                    fontSize: '10px'
                },
                zIndex: 5,
            })
        }
    }
}